import "../App.scss";
import "../styles/header.scss";

import { default as HelpOutlineRoundedIcon, default as SvgIcon } from "@mui/icons-material/HelpOutlineRounded";
import { Box, Drawer } from "@mui/material";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import userAPI from "../api/userAPI";
import Footer from "../components/Footer";
import swalDialog from "../helpers/swalErrorPopup";
import LogoActiveAndFreefit from "../img/logo_active_and_ff_for_menu.png";
import CardIcon from "../img/svg/card_icon.svg";
import CardIconWow from "../img/svg/card_icon_wow.svg";
import CloseIconWow from "../img/svg/close_black_new_design.svg";
import CloseIcon from "../img/svg/close_white_new_design.svg";
import HomeIcon from "../img/svg/home_icon.svg";
import HomeIconWow from "../img/svg/home_icon_wow.svg";
import { headerCustomDisplaying, isLoadChanger, setSidebarOpened } from "../store/mainSlice";
import { isPartnerClalit, isPartnerOvdimBari, selectIsMinor } from "../store/partnerStore";
import { updateIsHaveCreditCard } from "../store/userSlice";

function Sidebar() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const isClalit = useSelector(isPartnerClalit);
  const isOvdimBari = useSelector(isPartnerOvdimBari);
  const isMinor = useSelector(selectIsMinor);
  const mainUserParams = useSelector((state) => state.userSlice.mainUserData);
  const userParams = useSelector((state) => state.userSlice.userData);
  const [last4Digit, setLast4Digits] = React.useState("");
  const isHaveCreditCard = useSelector((state) => state.userSlice.isHaveCreditCard);
  const isSidebarOpened = useSelector((state) => state.mainSlice.isSidebarOpened);

  const termsOfUseUrl = isClalit
    ? "https://movement.activetrail.biz/%D7%AA%D7%A7%D7%A0%D7%95%D7%9F--WEB--free-fit"
    : "https://movement.activetrail.biz/%D7%AA%D7%A7%D7%A0%D7%95%D7%9F--WEB--free-fit";

  useEffect(() => {
    checkIsHasCreditCard();
    dispatch(headerCustomDisplaying(true));
    return () => {
      dispatch(headerCustomDisplaying(false));
    };
  }, []);

  const checkIsHasCreditCard = async () => {
    try {
      dispatch(isLoadChanger(true));
      let isHaveCreditCard = await userAPI.isClientHaveCreditCard({
        token: mainUserParams.Token,
        id: mainUserParams.ID,
        phone: mainUserParams.Phone,
      });

      if (isHaveCreditCard.data.Error !== 0) {
        throw {
          code: isHaveCreditCard.data.Error,
          mess: isHaveCreditCard.data.Message,
        };
      }

      dispatch(updateIsHaveCreditCard(JSON.parse(isHaveCreditCard.data.Data).HasCreditCard));

      const parsedLast4Digit = JSON.parse(isHaveCreditCard.data.Data);

      setLast4Digits(parsedLast4Digit.Last4Digit);

      dispatch(isLoadChanger(false));
    } catch (err) {
      dispatch(isLoadChanger(false));
      swalDialog(err);
    }
  };

  const handleClose = () => {
    dispatch(setSidebarOpened(false));
  };

  return (
    <Drawer
      anchor="right"
      open={isSidebarOpened}
      onClose={handleClose}
      slotProps={{
        paper: {
          sx: {
            width: "100%",
            backgroundColor: isOvdimBari ? "#3946C0" : isClalit ? "#28306f" : "#ffffff",
          },
        },
      }}
    >
      <Box className="sidebar-wrapper">
        <div className={isClalit || isOvdimBari ? "sidebar-back-img" : "sidebar-back-img-wow"}>
          <div className="sidebar-top-container">
            <div className="close-icon-new" onClick={handleClose}>
              <img src={isClalit || isOvdimBari ? CloseIcon : CloseIconWow} alt="close icon" />
            </div>

            {isClalit && (
              <div className="sidebar-logo-container">
                <img src={LogoActiveAndFreefit} alt="logo" className="sidebar-logo" />
              </div>
            )}
          </div>
          <div className="sidebar-top-text" style={{ color: isClalit || isOvdimBari ? "white" : "#003D62" }}>
            <p className="sidebar-text-first">
              {userParams.FirstName} {userParams.LastName}
            </p>
            <p className="sidebar-text-second">
              {userParams.CardNumber} {t("SUBSCRIPTION_NUMBER")}
            </p>
          </div>
        </div>
        <div className="sidebar-grey-line-wrapper">
          <div className="sidebar-grey-line"></div>
        </div>
        <div className="sidebar-btn-wrapper">
          <div className="sidebar-btn-subwrapper">
            <div
              className="sidebar-btn"
              style={{ color: isClalit || isOvdimBari ? "#FFFFFF" : "#000000" }}
              onClick={() => {
                handleClose();
                navigate("/");
              }}
            >
              <img src={isClalit || isOvdimBari ? HomeIcon : HomeIconWow} alt="" style={{ width: "20px" }} />
              <p>{t("TO_FREEFIT_HOME")}</p>
            </div>
            <div className="sidebar-grey-line-wrapper">
              <div className="sidebar-grey-line"></div>
            </div>

            {!isMinor && (
              <div
                className="sidebar-btn"
                style={{ color: isClalit || isOvdimBari ? "#FFFFFF" : "#000000" }}
                onClick={() => {
                  if (isHaveCreditCard) {
                    handleClose();
                    navigate("/card-details");
                  } else {
                    handleClose();
                    navigate("/addCard");
                  }
                }}
              >
                <img src={isClalit || isOvdimBari ? CardIcon : CardIconWow} alt="" />
                <p>{t("PAYMENT_METHOD")}</p>
              </div>
            )}
          </div>

          {!isMinor && (
            <div className="sidebar-grey-line-wrapper">
              <div className="sidebar-grey-line"></div>
            </div>
          )}

          <div
            className="sidebar-btn"
            style={{ color: isClalit || isOvdimBari ? "#FFFFFF" : "#000000" }}
            onClick={() => {
              handleClose();
              navigate(`/faq`);
            }}
          >
            <SvgIcon
              sx={{
                color: isClalit || isOvdimBari ? "#FFFFFF" : "#003D62",
                fontSize: "21px",
              }}
            >
              <HelpOutlineRoundedIcon />
            </SvgIcon>

            <p>{t("FAQ")}</p>
          </div>
        </div>
        <div className="sidebar-grey-line-wrapper">
          <div className="sidebar-grey-line"></div>
        </div>
      </Box>
      <footer className="sidebar-footer-wrapper">
        {isClalit && (
          <div className="sidebar-info-chat">
            <span
              className="multiple-entry-pass-details__footer__help__description"
              onClick={() => window.open(`https://wa.me/972559458809`, "_blank")}
              style={{ cursor: "pointer", color: "white" }}
            >
              {t("CHAT_WITH_US")}
            </span>
          </div>
        )}
        <div className="sidebar-info">
          <a className="sidebar-info-text" href={termsOfUseUrl} rel="noreferrer" onClick={handleClose}>
            {t("PRIVACY_POLICY")}
          </a>
          <p className="sidebar-info-text-dot">&#8226;</p>
          <a className="sidebar-info-text" href={termsOfUseUrl} rel="noreferrer" onClick={handleClose}>
            {t("TERMS_OF_USE")}
          </a>
        </div>

        <Footer />
      </footer>
    </Drawer>
  );
}

export default Sidebar;
